import type { JSX } from "react";

import { useLanguage } from "@4pace-cpq/core";
import { VMLineItems, VMSubItems } from "@4pace-cpq/core/api";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

export default function ArticleNumber({
  item,
}: {
  item: VMLineItems | VMSubItems;
}): JSX.Element {
  const { selectedLanguage } = useLanguage();

  const productProperties = item.product?.propertySet?.properties?.find(
    (property) => property.identifier === "DATASHEET_LINK",
  );

  const languageCode = selectedLanguage?.languageCode ?? "de-DE";

  const translation = productProperties?.translations?.[languageCode];

  function handleOnClick(datasheetUrl: string | null | undefined): void {
    if (window && datasheetUrl) {
      window.open(datasheetUrl, "_blank");
    }
  }

  return (
    <Box sx={{ width: "100px" }}>
      <Typography
        sx={{
          textDecoration: productProperties ? "underline" : "none",
          cursor: productProperties ? "pointer" : "inherit",
          fontSize: "inherit",
        }}
        onClick={() => handleOnClick(translation?.name)}
      >
        {item.product?.partId ?? "-"}
      </Typography>
    </Box>
  );
}
